import React from "react";
import { iotDisplayUseTabs } from "../../iot-config-constant";
import { BaseToggle } from "src/components/BaseToggle";
import { IotConfigResponse, UnionIotConfigUseTab } from "src/api/iot/iot-config-type";
import { BaseTooltip } from "src/components";

type Props = {
  iotDisplayConfig?: IotConfigResponse;
  handleToggleChange: (tabValue: UnionIotConfigUseTab, checked: boolean) => Promise<void>;
};

const IotUseTabControl = ({ iotDisplayConfig, handleToggleChange }: Props) => {
  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title flex-center-start">
        <h2 style={{ width: "auto" }} className="mr4">
          IoT 탭 설정
        </h2>
        <BaseTooltip
          touchIcon="QUESTION"
          children={
            <ul className="pl14">
              <li className="mb5">
                <span className="">기본 탭 : 기기별로 탭이 자동 생성되고, 탭 별로 해당하는 기기 리스트가 출력됩니다.</span>
              </li>
              <li>
                <span className="">커스텀 탭 : 아래 등록한 커스텀 탭과 해당 탭에 직접 등록한 기기 리스트가 출력됩니다.</span>
              </li>
            </ul>
          }
        />
      </div>
      {iotDisplayUseTabs.map((tab) => (
        <section key={tab.value} className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>{tab.label}</p>
          </div>
          <div className="contents-container__grid-contents">
            <div className="minmax400">
              <BaseToggle
                onChange={(checked: boolean) => handleToggleChange(tab.value, checked)}
                checked={iotDisplayConfig?.useTabs.includes(tab.value) || false}
              />
            </div>
          </div>
        </section>
      ))}
    </article>
  );
};

export default IotUseTabControl;
